const themes = [
  {
    name: 'default',
    label: "Light",
    dark: false,
    color: 'royalblue'
  },
  {
    name: 'scarlet',
    label: "Scarlet",
    dark: false,
    color: '#e04e41'
  },
  {
    name: 'seafoam',
    label: "Seafoam",
    dark: false,
    color: '#177380'
  },
  {
    name: 'hotpants',
    label: "Hotpants",
    dark: false,
    color: 'hotpink'
  },
  {
    name: 'tangerine',
    label: "Tangerine",
    dark: false,
    color: '#df5815'
  },
  {
    name: 'oaken',
    label: "Oaken",
    dark: false,
    color: 'saddlebrown'
  },
  {
    name: 'majesty',
    label: "Majesty",
    dark: false,
    color: 'blueviolet'
  },
  {
    name: 'gecko',
    label: "Gecko",
    dark: false,
    color: '#4ab92f'
  },
  {
    name: 'grayscale',
    label: "Grayscale",
    dark: false,
    color: '#999999'
  },
  {
    name: 'ozark',
    label: "Ozark",
    dark: true,
    color: '#5263af'
  },
  {
    name: 'cobalt',
    label: "Cobalt",
    dark: true,
    color: '#08439b'
  },
  {
    name: 'sorcery',
    label: "Sorcery",
    dark: true,
    color: '#ae91e8'
  },
  {
    name: 'punk',
    label: "Punk",
    dark: true,
    color: '#ff5050'
  },
  {
    name: 'ember',
    label: "Ember",
    dark: true,
    color: '#f76522'
  },
  {
    name: 'riot',
    label: "Riot",
    dark: true,
    color: 'hotpink'
  },
  {
    name: 'hacker',
    label: "Hacker",
    dark: true,
    color: '#4ab92f'
  },
  {
    name: 'mastodon',
    label: "Mastodon",
    dark: true,
    color: '#282C37'
  },
  {
    name: 'pitchblack',
    label: "Pitch Black",
    dark: true,
    color: '#000'
  },
  {
    name: 'dark-grayscale',
    label: "Dark Grayscale",
    dark: true,
    color: '#666'
  },
  {
    name: 'cohost_light',
    label: "Cohost Light",
    dark: false,
    color: '#83254F'
  },
  {
    name: 'vacuum',
    label: 'Vacuum',
    dark: false,
    color: '#F3F2EF'
  }
]

export { themes }
